import React from "react";

const HeadlineBanner = (
  {
    className = "",
    pre_title = "",
    title = "",
  }
) => {
  return (
    <section className={`headline-banner ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-11">
            <div className="headline-banner__pre-title">{pre_title}</div>
            <h2 className="headline-banner__title">{title}</h2>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeadlineBanner
